<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Основная Информация" @click="handleTabClick">
				<update-index :id="id"></update-index>
			</b-tab>
			<b-tab title="Email" @click="handleTabClick">
				<update-email :id="id"></update-email>
			</b-tab>
			<b-tab title="Загрузка документов" @click="handleTabClick">
				<update-file :id="id"></update-file>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import UpdateIndex from '@/components/event/update/index'
import UpdateEmail from '@/components/event/update/email'
import UpdateFile from '@/components/event/update/file'
export default {
	components: {
		'update-index': UpdateIndex,
		'update-email': UpdateEmail,
		'update-file': UpdateFile
	},
	data () {
		return {
			readyApiData: false,
			id: null,
			activeTab: 0,
			data: {}
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
	},
	methods: {
		handleTabClick (tab, event) {
			// this.$router.push({path: '/events/' + this.id + '/' + this.tabs[this.activeTab]})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/event/updateTabs/index.vue